export const formatRating = (rating: any): string => {
  if (!rating) {
    return rating
  }

  try {
    let newRating = ''
    newRating = Number(rating).toFixed(2) + ''
    return newRating
  } catch {
    return rating
  }
}
